import type { SVGProps } from 'react';
const SvgArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={8} fill="none" {...props}>
    <path d="M11.782 1.833 6.58 7.213h-.01s-.02.04-.04.06c-.15.15-.34.23-.53.23s-.39-.08-.53-.23L.218 1.832a.804.804 0 0 1 0-1.1.72.72 0 0 1 1.06 0L6 5.623l4.722-4.89c.29-.3.77-.3 1.06 0 .29.31.29.8 0 1.11z" />
  </svg>
);
export default SvgArrowIcon;
